<script lang="ts" setup>
const CLASS_ROOT = 'govuk-summary-list'

export interface IDSKSummaryListProps {
  data?: {
    key: string
    value: string | undefined
    id: string | number
  }[]
  actionText: string
  showActionText?: boolean
}

type IDSKSummaryListEmits = {
  (e: 'action', value: string): void
}

const emit = defineEmits<IDSKSummaryListEmits>()

const props = withDefaults(defineProps<IDSKSummaryListProps>(), {
  data: undefined,
  actionText: 'Upraviť',
  showActionText: true,
})
</script>

<template>
  <dl v-if="data" :class="CLASS_ROOT">
    <div v-for="(item, key) in props.data" :key="item?.id" :class="`${CLASS_ROOT}__row`">
      <dt :class="`${CLASS_ROOT}__key`">
        <slot name="link" :value="{ ...item }">
          {{ item.key }}
        </slot>
      </dt>
      <dd v-if="item?.value" :class="`${CLASS_ROOT}__value`">{{ item.value }}</dd>
      <dd v-if="showActionText" :class="`${CLASS_ROOT}__actions`">
        <IDSKLink
          href="#"
          no-visited-state
          @click.prevent="() => emit('action', item?.id, key)"
        >
          {{ props.actionText }}<span class="govuk-visually-hidden">{{ item?.id }}</span>
        </IDSKLink>
      </dd>
    </div>
  </dl>
</template>

<style scoped></style>
